import { render, staticRenderFns } from "./SearchComp.vue?vue&type=template&id=59b6eb43&scoped=true&"
import script from "./SearchComp.vue?vue&type=script&lang=js&"
export * from "./SearchComp.vue?vue&type=script&lang=js&"
import style0 from "./SearchComp.vue?vue&type=style&index=0&id=59b6eb43&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b6eb43",
  null
  
)

export default component.exports